import { getBlogPosts, IPostData } from 'app-lib/apis/ghostApi'
import { RootStore } from 'bzx-common/src/stores'
import * as mobx from 'mobx'
import AsyncData from 'app-lib/mobx/AsyncData'
export interface IBlogStoreProps {
  posts: AsyncData<IPostData[]>
}

export default class BlogStore implements IBlogStoreProps {
  rootStore: RootStore
  posts = new AsyncData<IPostData[]>([], getBlogPosts)

  get latestPosts() {
    return this.posts.value.slice(0, 3)
  }

  get ookiversityPosts() {
    return this.posts.value.filter((post) => post.tags.includes('ookiversity')).slice(0, 6)
  }

  /**
   * Helper to set values through mobx actions.
   */
  set(prop: keyof IBlogStoreProps, value: any) {
    ;(this[prop] as any) = value
  }

  /**
   * Helper to assign multiple props values through a mobx action.
   */
  assign(props: Partial<IBlogStoreProps>) {
    Object.assign(this, props)
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    mobx.makeAutoObservable(this, { rootStore: false }, { autoBind: true, deep: false })
  }
}
